<template>
  <div class="form-index-container">
    <el-card class="header-container">
      <el-row align="middle" type="flex" :gutter="5" style="height: 50px">
        <i class="el-icon-back" @click="$router.back(-1)" />
        <img class="header-logo" src="~@/assets/images/logo-blue.png" @click="$router.push({ path: '/home' })" />
        <h2 class="header-title">{{ formTitle }}</h2>
        <el-col />
        <el-button
          v-if="formPermissionState.canEdit"
          v-permission="['publish_publish']"
          type="primary"
          :disabled="formStatus != 2"
          @click="handlePublish"
        >
          更新
        </el-button>
        <el-button type="primary" icon="el-icon-view" @click="openPreviewHandle"> 预览 </el-button>
        <el-button type="primary" plain @click="getReleaseHistory"> 查看发布记录 </el-button>
        <!-- <el-button type="success" icon="el-icon-folder-add" @click="saveProjectAsTemplateHandle">
          保存至模板中心
        </el-button> -->
      </el-row>
    </el-card>
    <el-alert
      v-if="permissionReady && formPermissionState.canEdit && formStatus == 2"
      class="custom_alert"
      title="您正在编辑此问卷，在更新之前，您所做的更改将不会应用到正式答题"
      type="warning"
      center
      show-icon
    >
    </el-alert>
    <div class="main-container">
      <div class="left-menu-wrap">
        <el-menu
          v-if="permissionReady"
          :collapse="isCollapse"
          :default-active="defaultActiveMenu"
          class="el-menu-vertical"
          @select="menuSelectHandle"
        >
          <el-menu-item v-for="menuItem in getNavTree" :key="menuItem.menuId" :index="menuItem.path">
            <i :class="menuItem.icon" />
            <span slot="title">{{ menuItem.name }}</span>
          </el-menu-item>
        </el-menu>
        <i v-if="!isCollapse" class="el-icon-d-arrow-left" @click="collapseHandle" />
        <i v-else class="el-icon-d-arrow-right" @click="collapseHandle" />
      </div>
      <div class="right-content-container">
        <router-view v-if="permissionReady" />
      </div>
    </div>
    <!-- 预览 -->
    <el-dialog :visible.sync="previewDialogVisible" destroy-on-close fullscreen append-to-body>
      <pre-view :key="previewKey" :preview-qrcode="true" />
    </el-dialog>
    <template-create ref="templateCreate" :form-key="projectKey" />
    <!-- 发布记录 -->
    <history :historyData="historyData" ref="history" @toHistoryDetail="toHistoryDetail" />
    <!-- 发布记录详情 -->
    <el-dialog :visible.sync="detailDialogVisible" destroy-on-close fullscreen :show-close="false">
      <detail
        :key="detailInfo.id"
        ref="detailRef"
        :detailInfo="detailInfo"
        @goBack="() => (detailDialogVisible = false)"
      />
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store'
import PreView from '@/views/form/preview'
import TemplateCreate from '@/views/project/template/create'
import History from './components/history'
import Detail from './components/detail.vue'
import { publishFormRequest, getReleaseHistoryList } from '@/api/project/publish'
import { getFormPermission, queryProject } from '@/api/project/form'
import { pick } from 'lodash'
import { removeHtmlTag } from '@/utils'

export default {
  name: 'NewIndex',
  components: { TemplateCreate, PreView, History, Detail },
  provide() {
    return {
      formPermissionState: this.formPermissionState
    }
  },
  data() {
    return {
      previewKey: +new Date(),
      previewDialogVisible: false,
      defaultActiveMenu: 'editor',
      projectKey: null,
      isCollapse: false,
      formStatus: 0,
      historyData: [],
      detailDialogVisible: false,
      detailInfo: {},
      formTitle: store.getters['form/formTitle'],
      permissionReady: false,
      lastPermissionKey: '',
      formPermissionState: {
        formKey: '',
        isOwner: false,
        canView: false,
        canEdit: false,
        editPermissionMode: 'VIEW_BASED'
      }
    }
  },
  computed: {
    getNavTree() {
      try {
        let narData = JSON.parse(store.getters['user/navTree'])
        const filterNavData = _filterRoutes(narData).filter((item) => {
          return this.formPermissionState.canEdit || !this.isEditableRoute(item.path)
        })
        return filterNavData
      } catch (e) {
        return []
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      async handler(route) {
        const projectKeyChanged = this.lastPermissionKey !== route.query.key
        this.projectKey = route.query.key
        this.formStatus = route.query.status || this.formStatus
        this.defaultActiveMenu = route.path === '/form' ? '/form/editor' : route.path
        this.isCollapse = this.$store.state.form.isCollapse
        if (!this.projectKey) {
          return
        }
        await this.ensureFormPermission(route)
        if (this.permissionReady && (projectKeyChanged || !this.formTitle)) {
          this.queryProjectInfo()
        }
      }
    }
  },
  methods: {
    isEditableRoute(path) {
      return ['/form', '/form/editor', '/form/logic', '/form/theme', '/form/setting', '/form/publish'].includes(path)
    },
    buildRouteQuery() {
      return {
        key: this.projectKey,
        status: this.formStatus
      }
    },
    async ensureFormPermission(route) {
      if (!this.projectKey) {
        return
      }
      const hasCachedPermission =
        this.lastPermissionKey === this.projectKey && this.formPermissionState.formKey === this.projectKey
      if (hasCachedPermission) {
        if (!this.formPermissionState.canView) {
          this.$message.warning('抱歉，您没有该问卷的查看权限')
          this.$router.replace({ path: '/project/my' })
          return
        }
        if (this.isEditableRoute(route.path) && !this.formPermissionState.canEdit) {
          this.$message.warning('抱歉，您没有该问卷的修改权限')
          this.$router.replace({ path: '/form/data', query: this.buildRouteQuery() })
          return
        }
        this.permissionReady = true
        return
      }
      this.permissionReady = false
      if (this.lastPermissionKey !== this.projectKey) {
        this.formTitle = ''
      }
      try {
        const { data } = await getFormPermission(this.projectKey)
        this.formPermissionState.formKey = data?.formKey || this.projectKey
        this.formPermissionState.isOwner = !!data?.isOwner
        this.formPermissionState.canView = !!data?.canView
        this.formPermissionState.canEdit = !!data?.canEdit
        this.formPermissionState.editPermissionMode = data?.editPermissionMode || 'VIEW_BASED'
        this.lastPermissionKey = this.projectKey
        if (!this.formPermissionState.canView) {
          this.$message.warning('抱歉，您没有该问卷的查看权限')
          this.$router.replace({ path: '/project/my' })
          return
        }
        if (this.isEditableRoute(route.path) && !this.formPermissionState.canEdit) {
          this.$message.warning('抱歉，您没有该问卷的修改权限')
          this.$router.replace({ path: '/form/data', query: this.buildRouteQuery() })
          return
        }
        this.permissionReady = true
      } catch (error) {
        this.$message.warning('抱歉，您没有该问卷的查看权限')
        this.$router.replace({ path: '/project/my' })
      }
    },
    async queryProjectInfo() {
      const res = await queryProject(this.projectKey)
      if (res.data) {
        this.formStatus = res.data.status
        this.formTitle = removeHtmlTag(res.data.name)
        this.$store.dispatch('form/setFormTitle', removeHtmlTag(res.data.name))
      }
    },
    menuSelectHandle(index) {
      if (this.isEditableRoute(index) && !this.formPermissionState.canEdit) {
        this.$message.warning('抱歉，您没有该问卷的修改权限')
        this.$router.replace({ path: '/form/data', query: this.buildRouteQuery() })
        return
      }
      this.$router.replace({ path: index, query: { key: this.projectKey, status: this.formStatus } })
    },
    openPreviewHandle() {
      this.previewKey = +new Date()
      this.previewDialogVisible = true
    },
    async handlePublish() {
      await this.$confirm('更新后，答题者将使用当前版本进行答题，是否更新问卷？', '更新问卷', {
        confirmButtonText: '更新',
        cancelButtonText: '取消'
      })
        .then(async () => {
          await publishFormRequest({ formKey: this.projectKey })
          this.msgSuccess('更新成功')
        })
        .catch(() => {
          console.log('取消更新')
        })
    },
    saveProjectAsTemplateHandle() {
      this.$refs['templateCreate'].handleOpen()
    },
    collapseHandle() {
      let isCollapse = !this.isCollapse
      this.$store.dispatch('form/setIsCollapse', isCollapse).then(() => {
        this.isCollapse = isCollapse
      })
    },
    async getReleaseHistory() {
      const res = await getReleaseHistoryList({ current: 1, size: 20, formKey: this.projectKey })
      this.historyData = res.data.records
      this.$refs.history.historyDialogVisible = true
    },
    toHistoryDetail(scope) {
      const { row, $index } = scope
      this.detailDialogVisible = true
      this.detailInfo = { index: $index, ...row }
    }
  }
}
/**
 *
 * 路由数据格式转
 */
function _filterRoutes(routes) {
  let res =
    routes
      .filter((route) => route.name == '我的项目')[0]
      .children.map((childRouter) => {
        //只保留需要的数据
        let bkroute = pick(childRouter, ['id', 'icon', 'name', 'path', 'mate'])
        return bkroute
      }) || []
  return res
}
</script>

<style lang="scss" scoped>
.form-index-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.custom_alert {
  height: 50px;
  background-color: #f2f7ff;
  color: #606266;
  padding: 15px 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  ::v-deep .el-icon-warning {
    color: #409eff;
    margin-top: 5px;
  }
}

::v-deep .el-card__body {
  padding: 0;
}

::v-deep .el-menu {
  border: none;
  background-color: transparent;
}

.header-container {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  line-height: 50px;
  .el-icon-back {
    font-size: 22px;
    font-weight: 550;
    cursor: pointer;
    color: #000;
    margin-right: 75px;

    &:hover {
      color: rgb(32, 160, 255);
    }
  }

  .header-logo {
    height: 35px;
    width: 35px;
    vertical-align: middle;
  }

  .header-title {
    margin: 0 0 0 10px;
    font-size: 16px;
    font-weight: bold;
    white-space: nowrap;
  }
}

.main-container {
  width: 100vw;
  // height: calc(100vh - 60px);
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow: auto;

  .right-content-container {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
  }
}

.left-menu-wrap {
  max-width: 100px;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: solid 1px #f0f1f5;

  .el-menu-vertical:not(.el-menu--collapse) {
    width: 100px;
    min-height: 400px;
  }

  .el-icon-d-arrow-left,
  .el-icon-d-arrow-right {
    font-size: 19px;
    cursor: pointer;
    font-weight: 550;
    color: #000;
    margin-bottom: 100px;

    &:hover {
      color: rgb(32, 160, 255);
    }
  }
}

::v-deep.preview-container {
  background-color: #ffffff;
}
::v-deep .el-dialog__body {
  color: #25262b;
}
</style>
